<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelGestor"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },

  props: {
    nameField: {},
    empresaSelected: {},
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false },
    onlyRoots: { type: Boolean, default: false },
    filterCompany: { type: Boolean, default: true }
  },

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', this.onlyRoots ? 'id_usuario_gestor_root' : 'id_usuario_gestor', null);
        return;
      }
      this.isObject
        ? this.$emit('selectChange', this.onlyRoots ? 'id_usuario_gestor_root' : 'id_usuario_gestor', e)
        : this.$emit('selectChange', this.onlyRoots ? 'id_usuario_gestor_root' : 'id_usuario_gestor', e.id);
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option.id === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option.id === null);
        selectedActual = this.options.find((option) => option.id === null);
      }
      this.onChange(selectedActual);
      this.$emit('input', this.selected);
    },
    setOptions(empresaId) {
      let filter = this.onlyRoots ? 'root=true and ' : '';
      filter += this.filterCompany ? `id_empresa=${empresaId} and ` : '';
      this.isLoading = true;
      this.$atenaList
        .getCommon('usuario_gestor', {
          columns: 'id, nome',
          filter: filter + 'excluido=false',
          order: 'nome'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    },
    labelGestor({ nome }) {
      return `${nome}`;
    }
  },

  watch: {
    empresaSelected(newVal, oldVal) {
      if (this.filterCompany) {
        if (newVal !== oldVal) {
          this.setOptions(newVal);
        }
      }
    },
    nameField: function (value) {
      this.setValue(value);
    }
  },

  created() {
    if (this.empresaSelected && this.filterCompany) {
      this.setOptions(this.empresaSelected);
    } else {
      this.setOptions(null);
    }
  }
};
</script>

<style lang="scss" scoped></style>
